module.exports = {
    s3 : {
        fileLink: 'https://erp-modules-zolo-production.s3.amazonaws.com/',
    },
}


// WEBPACK FOOTER //
// ./src/config/keys.js